(() => {
  // fonction de détection des event envoyés par Trekkie
  function isTrekkie(event) {
    try {
      let eventData;

      if (Array.isArray(event) || event.length) {
        eventData = event;
      } else if (event.h) {
        eventData = [...event.h];
      } else {
        const { event: tempEvent, ...tempData } = event;
        eventData = ["event", tempEvent, tempData];
      }
      const [type, name, data] = eventData;

      if (
        data &&
        !data.__oz_event && // On se base sur le fait que nos appels ont un marqueur
        // on excle explicitement les events de Trekkie
        // https://help.shopify.com/en/manual/reports-and-analytics/google-analytics/tracking-ecommerce-events-using-analytics

        (name === "search" ||
          /*  name === "page_view" ||*/
          name === "view_item" ||
          name === "add_to_cart" ||
          // Les exclusions suivantes n'interviendront que dans le cas ou on est sur shopify +
          // sinon le script ne sera pzs placé, donc pas executé
          name === "begin_checkout" ||
          name === "add_payment_info" ||
          name === "purchase" ||
          name === "config" ||
          type === "consent")
      ) {
        //  console.log("Exclude Trekkie event", name, data);
        return true;
      }
    } catch (e) {}
    return false;
  }

  // On commence par créer un array patché pour le Datalayer qui va exclure les élements trekkie
  // qui seront envoyés avant que gtag ne soit chargé
  class DatalayerMaker extends Array {
    constructor() {
      super();
      // buffer
      this.bufferedDataLayer = [];
      // Flag de dépilement du buffer
      this.launched = false;

      this.addBuffered = this.addBuffered.bind(this);
    }

    /*
      Dépile le contenu du buffer
     */
    addBuffered() {
      // on set le flag
      this.launched = true;

      // Si des évènements ont été bufferisé on les pousse
      if (!this.bufferedDataLayer.length) return;
      this.push(...this.bufferedDataLayer);
      this.bufferedDataLayer.length = 0;
    }

    push(...elems) {
      // on filtre les élements trekkie
      const filteredElems = elems.filter((event) => !isTrekkie(event));

      if (filteredElems.length) {
        // On ne pousse des évènements dans le vrai dataLayer que lorsque le page_view a été émis par Trekkie
        if (this.launched) {
          super.push(...filteredElems);
        } else {
          // sinon on trie les élements
          const { pageViewEvent, mandatoryEvents, bufferableEvents } =
            filteredElems.reduce(
              (filtered, event) => {
                // page_view
                if (event.length && event[1] === "page_view") {
                  filtered.pageViewEvent = event;
                }
                // events gtm
                else if (/^gtm\./.test(event.event || "")) {
                  filtered.mandatoryEvents.push(event);
                } else if (event.length && event[0] === "js") {
                  filtered.mandatoryEvents.push(event);
                }
                // reste
                else {
                  filtered.bufferableEvents.push(event);
                }
                return filtered;
              },
              {
                pageViewEvent: null,
                mandatoryEvents: [],
                bufferableEvents: [],
              }
            );

          // on pousse dans tous les cas les évènements gtm.*** dans le dataLayer
          super.push(...mandatoryEvents);

          // et les autres dans le bufferedDataLayer
          this.bufferedDataLayer.push(...bufferableEvents);

          // puis on vérifie que le pageview est dans les nouveaux éléments
          if (pageViewEvent) {
            // et dans ce cas on le pousse dans le datalyer
            super.push(pageViewEvent);
            // et on dépile le conteu placé dans le buffer
            this.addBuffered();
          }
        }
      }
    }
  }

  window.dataLayer = new DatalayerMaker();
})();
